import React from "react";
import { useEffect } from "react";
import { motion } from "framer-motion";
import OnboardingCards from "./OnboardingCards";
import StartButton from "../misc/buttons/StartButton";
import SmartTabs from "./../tabs/SmartTabs";

const Onboarding = ({ serverData, setVisitCookie }) => {
  /* Hook to set the cookie on first visit */
  useEffect(() => {
    setVisitCookie("firstVisit", true, { path: "/" });

    // Code that will execute on unmount
    return () => {
      setVisitCookie("firstVisit", false, { path: "/" });
    };
  }, [setVisitCookie]);

  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.3,
        },
      }}
      className="onboarding-container"
    >
      <div className="onboarding">
        <OnboardingCards serverData={serverData} />
        <StartButton />

        <SmartTabs
          allRooms={serverData.allRooms ? serverData.allRooms : []}
          troubleReportData={
            serverData.troubleReports ? serverData.troubleReports : []
          }
        />
      </div>
    </motion.div>
  );
};
export default Onboarding;
